import React from 'react';
import { useSelector } from 'react-redux';
import { Button } from '../../../../../../ui';
import { RootState } from '../../../../../../utils/redux_store/store';
import commonStyles from '../../assigned_assessments.module.css';

type PrivacyNoticeModalProps = {
  setModalContent: (content: number) => void;
  isPractice: boolean;
};

export const PrivacyNoticeModal = ({
  setModalContent,
  isPractice,
}: PrivacyNoticeModalProps) => {
  const companyName = useSelector((state: RootState) => state.logo.companyName);

  const handleApply = () => {
    // Both practice and real should proceed to hardware check/setup
    setModalContent(2);
  };

  const handleDecline = () => {
    // Return to list
    setModalContent(0);
  };

  return (
    <div className={commonStyles.modalContentContainer}>
      <h2 className='text-2xl font-bold mb-4'>Privacy Notice</h2>
      <p className='text-primary-textGray text-sm mb-6'>
        Our site collects and stores information about you. More details about
        what we collect is found in our{ ' ' }
        <a
            className='text-md text-primary-dark font-medium underline'
            href='https://www.hiacuity.com/privacy-policy'
            target='_blank'
            rel='noopener noreferrer'
        >
          privacy policy
        </a>
        . <br />
        Please click the Accept All button if you agree to having your data
        collected and stored by{ ' ' }
        <span className='font-medium text-primary-main'>
          { companyName || 'our platform' }.
        </span>{ ' ' }
        If you do not agree, please click the Decline All button.
      </p>

      <div className='flex gap-4 justify-end border-t pt-5'>
        <Button
            variant='secondary'
            label='Decline All'
            onClick={handleDecline}
        />
        <Button
            variant='primary'
            label='Accept All'
            onClick={handleApply}
        />
      </div>
    </div>
  );
};
